(function(global) {
  "use strict";

  var EPSILON = 0.000001;
  var MAX_PIECES = 3;
  var MAX_JOINS = 2;

  function number(value) {
    var parsed = Number(String(value === null || value === undefined ? "" : value).replace(",", "."));
    return Number.isFinite(parsed) ? parsed : null;
  }
  function round(value, places) {
    var factor = Math.pow(10, places || 2);
    return Math.round((value + Number.EPSILON) * factor) / factor;
  }
  function safe(reason, message) {
    return { state: "professional_confirmation", reason: reason, message: message, candidates: [] };
  }
  function candidate(length, width, rollWidth, orientation) {
    var runLength = orientation === "length" ? length : width;
    var crossWidth = orientation === "length" ? width : length;
    var pieces = Math.ceil((crossWidth - EPSILON) / rollWidth);
    var joins = Math.max(0, pieces - 1);
    if (pieces > MAX_PIECES || joins > MAX_JOINS) return null;
    var totalLinearMetres = round(runLength * pieces, 2);
    var roomArea = round(length * width, 2);
    var suppliedArea = round(totalLinearMetres * rollWidth, 2);
    return {
      state: "ok",
      orientationKey: orientation,
      orientation: orientation === "length" ? "Run roll along room length" : "Rotate roll across room length",
      rollWidth: rollWidth,
      totalLinearMetres: totalLinearMetres,
      suppliedArea: suppliedArea,
      roomArea: roomArea,
      expectedSurplus: round(Math.max(0, suppliedArea - roomArea), 2),
      cutCount: pieces,
      joins: joins,
      cutPlan: pieces + " cut" + (pieces === 1 ? "" : "s") + " of " + round(runLength, 2) + "m",
      joinPlan: joins ? joins + " long join" + (joins === 1 ? "" : "s") : "No joins"
    };
  }
  function calculate(input) {
    var length = number(input && input.length);
    var width = number(input && input.width);
    var rollWidth = number(input && input.rollWidth);
    if (!length || !width || length <= 0 || width <= 0) return safe("invalid_dimensions", "Enter room length and width.");
    if (!rollWidth || rollWidth <= 0) return safe("missing_verified_width", "Verified sheet vinyl roll width is required.");
    if (length > 100 || width > 100) return safe("unreasonable_dimensions", "Room dimensions require professional confirmation.");
    var candidates = [candidate(length, width, rollWidth, "length"), candidate(length, width, rollWidth, "width")].filter(Boolean);
    if (!candidates.length) return safe("complex_join_plan", "This room needs a manual sheet-vinyl cutting and join plan.");
    candidates.sort(function(a, b) {
      if (a.joins !== b.joins) return a.joins - b.joins;
      if (a.cutCount !== b.cutCount) return a.cutCount - b.cutCount;
      if (a.suppliedArea !== b.suppliedArea) return a.suppliedArea - b.suppliedArea;
      return a.totalLinearMetres - b.totalLinearMetres;
    });
    return { state: "ok", recommended: candidates[0], alternatives: candidates.slice(1), candidates: candidates };
  }

  global.ArraSheetVinylLayoutEngine = { calculate: calculate };
  if (typeof global.dispatchEvent === "function" && typeof global.Event === "function") {
    global.dispatchEvent(new global.Event("af:sheet-vinyl-layout-engine-ready"));
  }
})(typeof window !== "undefined" ? window : globalThis);
